import { h, Fragment } from "preact"
import { useEffect, useRef } from "preact/hooks"

import { addVideoListeners } from "../../util/video-helper"
import { FarmerSlider } from "./slider"

export const Modal = ({ data, closeFunction, id, type, translations }) => {
  const closeFunctionOverride = (e) => {
    e.preventDefault()
    closeFunction()
  }

  return (
    <div key={`modal-${type}-${id}`} class="modal-container">
      <div class={`modal ${type}`}>
        <a
          href="#"
          class="modal__close--header"
          onClick={closeFunctionOverride}
        >
          <icon>×</icon>
        </a>
        <ModalContent {...{ data, type, translations }} />
        <a
          href="#"
          class="modal__close--footer"
          onClick={closeFunctionOverride}
        >
          <icon>×</icon>
          <span>{translations.close}</span>
        </a>
      </div>
    </div>
  )
}

export const ModalContent = ({ data, type, translations }) => {
  return (
    <>
      {data &&
        (type === "farmers" ? (
          <FarmerSlider {...{ data, translations }} />
        ) : (
          <GeneralModal {...{ data, translations }} />
        ))}
    </>
  )
}

export const GeneralModal = ({ data, translations }) => {
  return (
    <>
      <div class="header">{data.country}</div>
      <div
        class="image-container overlaytext"
        style={
          data.image_full && `background-image: url('${data.image_full}');`
        }
      >
        <h2>{data.header_title}</h2>
        <p>{data.header_text}</p>
      </div>
      <div class="modal__details">
        <div class="modal__details-left">
          <h3>{data.location}</h3>
          <div
            class="modal__details__list"
            dangerouslySetInnerHTML={{ __html: data.details }}
          />
        </div>
        <div class="modal__details-right">
          {data.location_map && <img src={data.location_map} />}
        </div>
      </div>
      {data.videos?.length > 0 && (
        <div class="modal__videos">
          {data.videos?.map((v) => (
            <Video
              video_url={v.url} // "https://vimeo.com/500831289"
              video_still={v.still} // "/media/medialibrary/2021/02/waw_launch_thumb_Tavola_disegno_1.png"
              key={v.url}
            />
          ))}
        </div>
      )}
      <div
        class="modal__content"
        dangerouslySetInnerHTML={{ __html: data.content }}
      />
      {data.shop_url && (
        <div class="footer">
          <a href={data.shop_url} class="shop-link">
            {translations.shop}
          </a>
        </div>
      )}
    </>
  )
}

export const Video = ({ video_url, video_still }) => {
  const vidRef = useRef()

  useEffect(() => {
    addVideoListeners([vidRef.current])
  }, [vidRef])

  return (
    <div class="ugb-video-popup square" data-video={video_url} ref={vidRef}>
      <div
        class="ugb-video-preview"
        style={`background-image: url('${video_still}');`}
      />
      <video class="ugb-video-preview" autoPlay loop muted>
        <source src={video_url} type="video/mp4" />
      </video>
      <div class="ugb-video-wrapper">
        <a href="#" />
        <span class="ugb-play-button">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="50"
            height="50"
            viewBox="0 0 34 34"
          >
            <path d="M17 34C7.6 34 0 26.4 0 17S7.6 0 17 0s17 7.6 17 17-7.6 17-17 17zm0-32C8.7 2 2 8.7 2 17s6.7 15 15 15 15-6.7 15-15S25.3 2 17 2z" />
            <path d="M12 25.7V8.3L27 17l-15 8.7zm2-14v10.5l9-5.3-9-5.2z" />
          </svg>
        </span>
      </div>
    </div>
  )
}
